import { useState } from "react";
import { PlayButton } from "../player";
import type { TrackLite } from "../types";

/** Cover art, or a coloured tile with the first letter when the source has none (or the link is dead). */
export function Cover({ url, id, title, size = 56, play }: { url: string | null; id: number; title: string; size?: number; play?: TrackLite }) {
  const art = <Art url={url} id={id} title={title} size={size} />;
  return play?.hasPreview ? <span className="cover-wrap">{art}<PlayButton track={play} /></span> : art;
}

function Art({ url, id, title, size }: { url: string | null; id: number; title: string; size: number }) {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size } as const;
  if (url && !broken) {
    return (
      <img className="cover" src={url} alt="" width={size} height={size} loading="lazy"
        referrerPolicy="no-referrer" onError={() => setBroken(true)} style={style} />
    );
  }
  const hue = (id * 47) % 360;
  return (
    <div className="cover cover--empty" aria-hidden="true" style={{ ...style, background: `linear-gradient(135deg, hsl(${hue} 45% 42%), hsl(${(hue + 40) % 360} 50% 28%))`, fontSize: size * 0.42 }}>
      {title.trim().charAt(0).toUpperCase()}
    </div>
  );
}
